export default __webpack_public_path__ + "static/media/image-main-3-w.b27b152b.webp";